import { Link } from 'react-router-dom';
import { useContent } from '@/services/siteData';
import { IcoInstagram } from './icons';

export function Footer() {
  const { contact, branding } = useContent();
  const cddLogo = branding?.cddLogo || '/assets/cdd-logo.png';
  return (
    <>
      {/* Proud group member — La Compagnie des Desserts */}
      <section className="cdd">
        <div className="cdd-inner">
          <div className="cdd-logo">
            <p className="cdd-logo-text">Didier's Patisserie are a proud group member of</p>
            <img
              className="cdd-logo-image"
              src={cddLogo}
              width={1118}
              height={184}
              alt="La Compagnie des Desserts"
            />
          </div>
          <div className="cdd-details">
            <div className="cdd-details-label">To place an order or make an enquiry:</div>
            <p>
              <a className="cdd-details-link" href={`mailto:${contact.email}`}>
                {contact.email}
              </a>
            </p>
            <p>
              <a className="cdd-details-link large" href={contact.phoneHref}>
                {contact.phone}
              </a>
            </p>
          </div>
        </div>
      </section>

      <footer className="site-footer">
        <div className="footer-bar">
          <a className="footer-ig-link" href={contact.instagramUrl} target="_blank" rel="noopener">
            <IcoInstagram size={22} /> {contact.instagram}
          </a>
        </div>
        <div className="footer-bottom">
          <p className="footer-strap">London's finest patisserie made to royal standards</p>
          <p className="footer-copyright">
            Copyright 2026&copy; Didier's Patisserie Ltd.
            <br />
            Regd. in England &amp; Wales No. 03067961
            <br />
            UK VAT Number: GB662390237
            <span className="links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/cookie">Cookie Policy</Link>
            </span>
          </p>
        </div>
      </footer>
    </>
  );
}
